import { usePurchaseOrdersGetById } from '@/shared/api/generated/purchase-orders/purchase-orders';

export function usePoCommandCenter(identifier: string | undefined, poId: string | undefined) {
	return usePurchaseOrdersGetById(
		{ identifier: identifier!, id: poId! },
		{ query: { enabled: !!identifier && !!poId, staleTime: 5 * 60 * 1000, refetchOnWindowFocus: false, retry: 1 } }
	);
}
